import { useTranslation } from 'react-i18next';
import i18n from 'locales/i18n';

import PageWrapper from 'components/page/PageWrapper';

import bg from 'assets/images/banner/banner02.jpg'
import imgKo from 'assets/images/solutions/monitoring/ko/img.png';
import imgEn from 'assets/images/solutions/monitoring/en/img.png';

export default function Monitoring(){
  const {t} = useTranslation();
  const locale = i18n.language??'ko';
  const menuName= t('menu.sub-monitoring');
  const path=[
    {url:'/solutions', name:t('menu.main-solutions')},
    {url:'/solutions/monitoring', name:menuName}];
  const title = t('monitoring.banner.title')
  const comment = t('monitoring.banner.comment')

  const imgs = {ko:imgKo, en:imgEn}
  return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
      <div className="flex justify-center w-full my-10 lg:my-20 px-mobile">
        <div className="flex flex-col  w-full lg:w-[1200px]">
          <div className="flex flex-col items-center mb-20 text-center">
            <p className="mb-6 text-2xl font-semibold lg:text-3xl lg:font-normal">{t('monitoring.body.title')}</p>
            <p className="text-xs lg:text-base"
            dangerouslySetInnerHTML={{__html:t('monitoring.body.sub-title')}}></p>
          </div>
          <div className='px-4'>
            <img src={imgs[locale]} alt='monitoring'/>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}